<template>

  <section class="dp-layout">
    <!-- 
    <section class="dp-left" :style="{
      display: this.$store.state.HasChildrenDepartment ? 'block' : 'none',
    }"> -->
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!-- 类型切换标签 -->
      <el-tabs v-model="activeTypeTab" class="pe-type-tabs" @tab-click="handleTabChange">
        <el-tab-pane label="洗衣机" name="1"></el-tab-pane>
        <el-tab-pane label="吹风机" name="2"></el-tab-pane>
      </el-tabs>
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!-- 洗衣机表格 -->
      <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
      <div class="tbl-scroll-host">
      <el-table height="100%" v-show="activeTypeTab === '1'" :data="users" v-loading="listLoading"
        @selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow" ref="table1" class="custom-tbl" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="Type" label="类型" :formatter="formatTouchTypeDirection"></el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门"></el-table-column>
        <el-table-column prop="Outflow" label="定值模式">
          <template slot-scope="scope">
            {{ formatOutflow(scope.row.Outflow) }}
          </template>
        </el-table-column>
        <el-table-column prop="Delayed" label="延时周期秒"></el-table-column>
        <el-table-column prop="Offline" label="是否允许离线">
          <template slot-scope="scope">
            {{ formatOffline(scope.row.Offline) }}
          </template>
        </el-table-column>
        <el-table-column prop="Validity" label="白名单有效期天数"></el-table-column>
        <el-table-column prop="Rotation" label="屏幕旋转"></el-table-column>
        <el-table-column prop="Insert" label="是否持续放卡">
          <template slot-scope="scope">
            {{ formatInsert(scope.row.Insert) }}
          </template>
        </el-table-column>
        <el-table-column label="价格">
          <template slot-scope="scope">
            <div>
              <div>脱水：{{ scope.row.Dehydration }}</div>
              <div>快洗：{{ scope.row.Express }}</div>
              <div>普洗：{{ scope.row.Service }}</div>
              <div>大件：{{ scope.row.Large }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="TerminalDesc" label="备注"></el-table-column>
        <el-table-column prop="CreateTime" label="添加时间"></el-table-column>
        <!-- 新增操作列 -->
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openApplyDialog(scope.row)">应用</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!-- 吹风机表格 -->
      <!-- 列表：tbl-scroll-host + height 保证操作列与表体同步滚动。最后更新：2026-08-31 -->
      <div class="tbl-scroll-host">
      <el-table height="100%" v-show="activeTypeTab === '2'" :data="users" v-loading="listLoading"
        @selection-change="handleSelectionChange" @select="dialogCheck" @row-click="selectCurrentRow" ref="table2" class="custom-tbl" style="width: 100%">
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="Name" label="名称"></el-table-column>
        <el-table-column prop="Type" label="类型" :formatter="formatTouchTypeDirection"></el-table-column>
        <el-table-column prop="DepartmentName" label="所属部门"></el-table-column>
        <el-table-column prop="Mode" label="模式">
          <template slot-scope="scope">
            {{ formatMode(scope.row.Mode) }}
          </template>
        </el-table-column>
        <el-table-column prop="Outflow" label="定值模式">
          <template slot-scope="scope">
            {{ formatOutflow(scope.row.Outflow) }}
          </template>
        </el-table-column>
        <el-table-column prop="Rate" label="单位价格"></el-table-column>
        <el-table-column prop="Cycle" label="单位时间（秒）"></el-table-column>
        <el-table-column prop="Delayed" label="延时周期秒"></el-table-column>
        <el-table-column prop="Offline" label="是否允许离线">
          <template slot-scope="scope">
            {{ formatOffline(scope.row.Offline) }}
          </template>
        </el-table-column>
        <el-table-column prop="Validity" label="白名单有效期天数"></el-table-column>
        <el-table-column prop="Rotation" label="屏幕旋转"></el-table-column>
        <el-table-column prop="Insert" label="是否持续放卡">
          <template slot-scope="scope">
            {{ formatInsert(scope.row.Insert) }}
          </template>
        </el-table-column>
        <el-table-column prop="TerminalDesc" label="备注"></el-table-column>
        <el-table-column prop="CreateTime" label="添加时间"></el-table-column>
        <!-- 新增操作列 -->
        <el-table-column label="操作" width="100" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="openApplyDialog(scope.row)">应用</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right">
        </el-pagination>
      </el-col>

      <!-- 编辑界面 -->
      <el-dialog title="编辑信息" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="editForm" label-width="140px" :rules="editFormRules" ref="editForm">
          <!-- 使用 el-row 和 el-col 进行布局 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="名称" prop="Name">
                <el-input v-model="editForm.Name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">

            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="类型" prop="Type">
                <el-select v-model="editForm.Type" placeholder="请选择类型">
                  <el-option label="吹风机" value="2"></el-option>
                  <el-option label="洗衣机" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.Type === '2'">
              <el-form-item label="模式" prop="Mode">
                <el-select v-model="editForm.Mode" placeholder="请选择模式">
                  <el-option label="计时" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12" v-if="editForm.Type === '2'">
              <el-form-item label="单位价格" prop="Rate">
                <el-input v-model="editForm.Rate" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.Type === '2'">
              <el-form-item label="单位时间（秒）" prop="Cycle">
                <el-input v-model="editForm.Cycle" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="定值模式" prop="Outflow">
                <el-select v-model="editForm.Outflow" placeholder="请选择定值定值模式">
                  <el-option label="开启" value="2"></el-option>
                  <el-option label="关闭" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="延时周期秒" prop="Delayed">
                <el-input v-model="editForm.Delayed" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="是否允许离线" prop="Offline">
                <el-select v-model="editForm.Offline" placeholder="请选择是否允许离线">
                  <el-option label="不允许" value="1"></el-option>
                  <el-option label="允许" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="白名单有效期天数" prop="Validity">
                <el-input v-model="editForm.Validity" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="屏幕旋转" prop="Rotation">
                <el-input v-model="editForm.Rotation" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否持续放卡" prop="Insert">
                <el-select v-model="editForm.Insert" placeholder="请选择是否持续放卡">
                  <el-option label="关闭" value="1"></el-option>
                  <el-option label="开启" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12" v-if="editForm.Type === '1'">
              <el-form-item label="脱水票价" prop="Dehydration">
                <el-input v-model="editForm.Dehydration" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.Type === '1'">
              <el-form-item label="快洗票价" prop="Express">
                <el-input v-model="editForm.Express" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12" v-if="editForm.Type === '1'">
              <el-form-item label="普洗票价" prop="Service">
                <el-input v-model="editForm.Service" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.Type === '1'">
              <el-form-item label="大件票价" prop="Large">
                <el-input v-model="editForm.Large" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 新增界面 -->
      <el-dialog title="新增信息" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
        destroy-on-close>
        <el-form :model="addForm" label-width="140px" :rules="addFormRules" ref="addForm" class="demo-form-inline">
          <!-- 使用 el-row 和 el-col 进行布局 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="名称" prop="Name">
                <el-input v-model="addForm.Name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">

            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="类型" prop="Type">
                <el-select v-model="addForm.Type" placeholder="请选择类型">
                  <el-option label="吹风机" value="2"></el-option>
                  <el-option label="洗衣机" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="addForm.Type === '2'">
              <el-form-item label="模式" prop="Mode">
                <el-select v-model="addForm.Mode" placeholder="请选择模式">
                  <el-option label="计时" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12" v-if="addForm.Type === '2'">
              <el-form-item label="单位价格" prop="Rate">
                <el-input v-model="addForm.Rate" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="addForm.Type === '2'">
              <el-form-item label="单位时间（秒）" prop="Cycle">
                <el-input v-model="addForm.Cycle" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="定值模式" prop="Outflow">
                <el-select v-model="addForm.Outflow" placeholder="请选择定值模式状态">
                  <el-option label="开启" value="2"></el-option>
                  <el-option label="关闭" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="延时周期秒" prop="Delayed">
                <el-input v-model="addForm.Delayed" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="是否允许离线" prop="Offline">
                <el-select v-model="addForm.Offline" placeholder="请选择是否允许离线">
                  <el-option label="不允许" value="1"></el-option>
                  <el-option label="允许" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="白名单有效期天数" prop="Validity">
                <el-input v-model="addForm.Validity" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="屏幕旋转" prop="Rotation">
                <el-input v-model="addForm.Rotation" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否持续放卡" prop="Insert">
                <el-select v-model="addForm.Insert" placeholder="请选择是否持续放卡">
                  <el-option label="关闭" value="1"></el-option>
                  <el-option label="开启" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12" v-if="addForm.Type === '1'">
              <el-form-item label="脱水票价" prop="Dehydration">
                <el-input v-model="addForm.Dehydration" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="addForm.Type === '1'">
              <el-form-item label="快洗票价" prop="Express">
                <el-input v-model="addForm.Express" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12" v-if="addForm.Type === '1'">
              <el-form-item label="普洗票价" prop="Service">
                <el-input v-model="addForm.Service" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="addForm.Type === '1'">
              <el-form-item label="大件票价" prop="Large">
                <el-input v-model="addForm.Large" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <!-- 应用设备弹窗 -->
      <el-dialog title="应用设备" :visible.sync="applyDialogVisible" width="50%">
        <div>
          <div class="toolbar-filter-bar toolbar-filter-bar--embed">
            <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="addDevice">
              <div class="toolbar-filter-fields">
                <el-form-item>
                  <el-select v-model="selectedDeviceId" placeholder="设备" filterable class="toolbar-field-w-xl" style="width: 360px">
                    <el-option v-for="item in deviceSelectList" :key="item.KqTerminalId" :label="`${item.KqTerminalId} - ${item.TerminalName}（${item.TerminalTypeId == 5
                      ? '手持机消费终端'
                      : item.TouchTypeDirection == 1
                        ? '洗衣机'
                        : item.TouchTypeDirection == 2
                          ? '吹风机'
                          : ''
                      }）`" :value="item.KqTerminalId" :disabled="activeTypeTab == 1
                        ? !(item.TerminalTypeId == 5 || item.TouchTypeDirection == 1)
                        : !(item.TouchTypeDirection == 2)" />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="success" size="small" icon="el-icon-plus" @click="addDevice">添加</el-button>
                </el-form-item>
              </div>
            </el-form>
          </div>

          <el-table :data="applyDeviceList" style="width: 100%; margin-top: 10px;">
            <el-table-column prop="KqTerminalId" label="设备标识"></el-table-column>
            <el-table-column prop="TerminalName" label="设备名称"></el-table-column>
            <el-table-column prop="TerminalDesc" label="备注"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="text" @click="removeDevice(scope.$index)">移除</el-button>
                <el-button type="primary" size="mini" @click="sendParameter(scope.row)">下发</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="applyDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>

    </section>

  </section>

</template>

<script>
import util from "../../../util/date";
import { testapi } from '../../api/modules/auth';
import { getPowerEquipmentParameterListPage, removePowerEquipmentParameter, editPowerEquipmentParameter, addPowerEquipmentParameter, AddDeviceEquipmentParameter, GetDeviceListById, DelDeviceEquipmentParameter, SyucParameter } from '../../api/modules/dormitory';
import { getTeachingDepartmentTree } from '../../api/modules/department';
import { BaseApiUrl } from '../../api/base';
import { syucUser } from '../../api/modules/consumption';
import { getDeviveList } from '../../api/modules/attendance';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'
import es from "@/lang/es";

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
      },
      BaseApiUrl: BaseApiUrl, //网络前缀
      searchList: [
        {
          label: '名称',
          key: 'name',
        },
      ],
      users: [],
      roles: [],
      options: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      liveTypeList: [],
      liveTypeId: "",
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      activeTypeTab: "1", // 默认显示洗衣机
      editFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        Type: [
          { required: true, message: '请选择终端类型', trigger: 'change' }
        ],
        Mode: [
          { required: true, message: '请选择模式', trigger: 'change' }
        ],
        Rate: [
          { required: true, message: '请输入单位价格', trigger: 'blur' }
        ],
        Cycle: [
          { required: true, message: '请输入单位时间/秒', trigger: 'blur' }
        ],
        Outflow: [
          { required: true, message: '请选择定值模式状态', trigger: 'change' }
        ],
        Delayed: [
          { required: true, message: '请输入延时周期秒', trigger: 'blur' }
        ],
        Offline: [
          { required: true, message: '请选择是否允许离线', trigger: 'change' }
        ],
        Validity: [
          { required: true, message: '请输入白名单有效期天数', trigger: 'blur' }
        ],
        Rotation: [
          { required: true, message: '请输入屏幕旋转', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== '1' && value !== 1) {
                callback(new Error('屏幕旋转只能输入1'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        Insert: [
          { required: true, message: '请选择是否持续放卡', trigger: 'change' }
        ],
        Dehydration: [
          { required: true, message: '请输入脱水票价', trigger: 'blur' }
        ],
        Express: [
          { required: true, message: '请输入快洗票价', trigger: 'blur' }
        ],
        Service: [
          { required: true, message: '请输入普洗票价', trigger: 'blur' }
        ],
        Large: [
          { required: true, message: '请输入大件票价', trigger: 'blur' }
        ],
      },
      // 编辑界面数据
      editForm: {
        Id: 0,
        Name: "",
        Type: "",
        Mode: "",
        Rate: "",
        Cycle: "",
        Outflow: "",
        Delayed: "",
        Offline: "",
        Validity: "",
        Rotation: "",
        Insert: "",
        Dehydration: "",
        Express: "",
        Service: "",
        Large: "",
        TerminalDesc: "",
        DepartmentId: 0,
        TerminalTypeId: "3",
      },
      isResouceShow: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        Type: [
          { required: true, message: '请选择终端类型', trigger: 'change' }
        ],
        Mode: [
          { required: true, message: '请选择模式', trigger: 'change' }
        ],
        Rate: [
          { required: true, message: '请输入单位价格', trigger: 'blur' }
        ],
        Cycle: [
          { required: true, message: '请输入单位时间/升数', trigger: 'blur' }
        ],
        Outflow: [
          { required: true, message: '请选择定值模式状态', trigger: 'change' }
        ],
        Delayed: [
          { required: true, message: '请输入延时周期秒', trigger: 'blur' }
        ],
        Offline: [
          { required: true, message: '请选择是否允许离线', trigger: 'change' }
        ],
        Validity: [
          { required: true, message: '请输入白名单有效期天数', trigger: 'blur' }
        ],
        Rotation: [
          { required: true, message: '请输入屏幕旋转', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value !== '1' && value !== 1) {
                callback(new Error('屏幕旋转只能输入1'));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }
        ],
        Insert: [
          { required: true, message: '请选择是否持续放卡', trigger: 'change' }
        ],
        Dehydration: [
          { required: true, message: '请输入脱水票价', trigger: 'blur' }
        ],
        Express: [
          { required: true, message: '请输入快洗票价', trigger: 'blur' }
        ],
        Service: [
          { required: true, message: '请输入普洗票价', trigger: 'blur' }
        ],
        Large: [
          { required: true, message: '请输入大件票价', trigger: 'blur' }
        ]
      },
      // 新增界面数据
      addForm: {
        Name: "",
        Type: "",
        Mode: "",
        Rate: "",
        Cycle: "",
        Outflow: "",
        Delayed: "",
        Offline: "",
        Validity: "",
        Rotation: "",
        Insert: "",
        Dehydration: "",
        Express: "",
        Service: "",
        Large: "",
        TerminalDesc: "",
        DepartmentId: 0,
        TerminalTypeId: "3",
      },
      DepartmentId: 0,
      currentUserId: '',
      imageUrl: '',
      imageLoadding: false,
      multipleSelection: [],
      applyDialogVisible: false,
      applyDeviceList: [],
      newDeviceId: '',
      applyRow: null,

      deviceSelectList: [],
      selectedDeviceId: '',

    };
  },
  methods: {

    async openApplyDialog(row) {
      this.applyRow = row;
      this.newDeviceId = '';
      this.selectedDeviceId = '';
      this.applyDialogVisible = true;
      this.refreshApplyDeviceList();
      // 获取设备下拉列表
      const res = await getDeviveList({
        departmentId: this.DepartmentId,
        type: 3
      });
      this.deviceSelectList = res.data.response || [];
    },


    // async addDevice() {
    //   const val = this.newDeviceId && this.newDeviceId.trim();
    //   if (!val) {
    //     this.$message.warning('请输入设备标识');
    //     return;
    //   }
    //   this.$confirm('请谨慎操作,将会覆盖之前的数据，是否继续？', '提示', { type: 'warning' })
    //     .then(() => {
    //       this.doAddDevice(val); // 调用实际添加方法
    //     })
    //     .catch(() => { });
    // },

    async addDevice() {
      const val = this.selectedDeviceId && this.selectedDeviceId.trim();
      if (!val) {
        this.$message.warning('请选择设备');
        return;
      }
      this.$confirm('请谨慎操作,将会覆盖之前的数据，是否继续？', '提示', { type: 'warning' })
        .then(() => {
          this.doAddDevice(val);
        })
        .catch(() => { });
    },

    async doAddDevice(val) {
      try {
        const res = await AddDeviceEquipmentParameter({
          Id: this.applyRow.Id,
          KqTerminalId: val
        });
        if (res.data && res.data.success) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.newDeviceId = '';
          this.refreshApplyDeviceList();
        } else {
          this.$message({
            message: res.data && res.data.msg ? res.data.msg : "添加失败",
            type: "error",
          });
        }
      } catch (e) {
        this.$message.error('添加失败');
      }
    },
    // 查询设备列表，调用 GetDeviceListById
    async refreshApplyDeviceList() {
      try {
        const res = await GetDeviceListById({ id: this.applyRow.Id });
        this.applyDeviceList = res.data.response || [];
      } catch (e) {
        this.applyDeviceList = [];
      }
    },
    async removeDevice(idx) {
      const device = this.applyDeviceList[idx];
      this.$confirm("确认移除该设备吗?", "提示", { type: "warning" })
        .then(async () => {
          try {
            const res = await DelDeviceEquipmentParameter({
              Id: this.applyRow.Id,
              KqTerminalId: device.KqTerminalId
            });
            if (res.data && res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.refreshApplyDeviceList();
            } else {
              this.$message({
                message: res.data && res.data.msg ? res.data.msg : "删除失败",
                type: "error",
              });
            }
          } catch (e) {
            this.$message.error("删除失败");
          }
        })
        .catch(() => { });
    },

    async sendParameter(row) {
      try {
        const res = await SyucParameter({
          Id: this.applyRow.Id,
          KqTerminalId: row.KqTerminalId
        });
        if (res.data && res.data.success) {
          this.$message({
            message: "下发成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.data && res.data.msg ? res.data.msg : "下发失败",
            type: "error",
          });
        }
      } catch (e) {
        this.$message.error("下发失败");
      }
    },

    handleTabChange() {
      this.handleQuery();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    formatTouchTypeDirection: function (row, column) {
      if (row.Type == "1") {
        return "洗衣机";
      } else if (row.Type == "2") {
        return "吹风机";
      } else {
        return "";
      }
    },

    formatMode: function (mode) {
      if (mode === "1") {
        return "计时";
      } else if (mode === "2") {
        return "计量";
      } else {
        return "";
      }
    },
    formatOutflow: function (outflow) {
      if (outflow === "1" || outflow === 1) {
        return "关闭";
      } else if (outflow === "2" || outflow === 2) {
        return "开启";
      } else {
        return "";
      }
    },
    formatOffline: function (offline) {
      if (offline === "1") {
        return "不允许";
      } else if (offline === "2") {
        return "允许";
      } else {
        return "";
      }
    },
    formatInsert: function (insert) {
      if (insert === "1") {
        return "关闭";
      } else if (insert === "2") {
        return "开启";
      } else {
        return "";
      }
    },
    beforeAvatarUpload(file) {
      // 这里可以过滤不要的文件
      this.imageLoadding = true
      return true
    },

    //头像上传成功
    handleAvatarSuccess(res, file) {
      this.imageLoadding = false
      console.log(res)
      this.imageUrl = res.response
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
      let para = {
        id: this.DepartmentId,
      };
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      let activeTable = this.activeTypeTab === "1" ? this.$refs.table1 : this.$refs.table2;
      if (activeTable) {
        activeTable.clearSelection();
      }
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        let activeTable = this.activeTypeTab === "1" ? this.$refs.table1 : this.$refs.table2;
        if (activeTable) {
          activeTable.clearSelection();
          this.$nextTick(() => {
            activeTable.toggleRowSelection(val, true);
          });
        }
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },

    //获取用户列表
    handleQuery() {
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeTypeTab // 使用标签类型
      }
      this.listLoading = true;

      testapi();
      //NProgress.start();
      getPowerEquipmentParameterListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择要删除的一行数据！',
          type: 'error',
        })
        return
      }

      var row = rows[0];

      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.Id };
          removePowerEquipmentParameter(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.handleQuery();
          });
        })
        .catch(() => { });
    },
    //显示编辑界面
    handleEdit() {

      var rows = this.multipleSelection

      if (rows.length == 0 || rows.length > 1) {
        this.$message({
          message: '请选择一行数据进行编辑！',
          type: 'error',
        })
        return
      }

      var row = rows[0];

      this.options = [];

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editForm.Type = this.activeTypeTab; // 编辑时类型与标签同步
    },
    //显示新增界面
    handleAdd() {
      if (!this.DepartmentId || this.DepartmentId === 0) {
        this.$message({
          message: "请先选择左侧所属机构！",
          type: "warning",
        });
        return;
      }
      this.addFormVisible = true;
      this.options = [];
      this.addForm = {
        KqTerminalId: "",
        TerminalName: "",
        Type: this.activeTypeTab, // 新增时类型与标签同步
        Mode: "1",
        Rate: "",
        Cycle: "",
        Outflow: "",
        Delayed: "",
        Offline: "2",
        Validity: "",
        Rotation: "",
        Insert: "2",
        Dehydration: "",
        Express: "",
        Service: "",
        Large: "",
        TerminalDesc: "",
        DepartmentId: this.DepartmentId,
        TerminalTypeId: "3",
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);

            editPowerEquipmentParameter(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.addForm);

            addPowerEquipmentParameter(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.handleQuery();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
                this.addLoading = false;
              }
            });
          });
        }
      });
    },
    handleSyucUser() {
      var rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '至少选择一个设备进行下发！',
          type: 'error',
        })
        return
      }

      if (rows.length > 5) {
        this.$message({
          message: '最多只能选择五个设备！',
          type: 'error',
        })
        return
      }

      let arr = [];
      rows.forEach(e => {
        arr.push(e.KqTerminalId)
      })

      let para = {
        deviceNos: arr,
        way: '0'
      };

      this.$confirm("确认进行下发吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          syucUser(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "下发成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => { });

      console.log(this.multipleSelection);
    },
    handleDelUser() {
      var rows = this.multipleSelection

      if (rows.length == 0) {
        this.$message({
          message: '至少选择一个设备操作！',
          type: 'error',
        })
        return
      }

      if (rows.length > 5) {
        this.$message({
          message: '最多只能选择五个设备！',
          type: 'error',
        })
        return
      }

      let arr = [];
      rows.forEach(e => {
        arr.push(e.KqTerminalId)
      })

      let para = {
        deviceNos: arr,
        way: '2'
      };

      this.$confirm("确认进行清空人员吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          syucUser(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => { });

      console.log(this.multipleSelection);
    }
  },
  mounted() {

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.pe-type-tabs {
  flex: 0 0 auto;
  margin-bottom: 10px;
}

/* .custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
} */

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: var(--btn-primary, #2563eb);
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 106.8px;
  height: 106.8px;
  line-height: 106.8px;
  text-align: center;
}

.avatar {
  width: 106.8px;
  height: 106.8px;
  display: block;
}

.avatar-uploader-tip {
  position: absolute;
  width: 100%;
  height: 1vw;
  bottom: 20px;
  color: gray;
  z-index: 99;
}
</style>
